import { Component } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HxOrderService } from 'hx-services';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { TranslocoDirective, TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { NzAffixComponent } from 'ng-zorro-antd/affix';
import { NzPageHeaderComponent, NzPageHeaderSubtitleDirective, NzPageHeaderTitleDirective } from 'ng-zorro-antd/page-header';
import { NzCollapseComponent, NzCollapsePanelComponent } from 'ng-zorro-antd/collapse';
import { NzFormControlComponent, NzFormDirective, NzFormItemComponent, NzFormLabelComponent } from 'ng-zorro-antd/form';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzInputNumberComponent } from 'ng-zorro-antd/input-number';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';

import { NzIconDirective } from 'ng-zorro-antd/icon';

interface FormModel {
  orderId: number;
  deliveryLat: number;
  deliveryLong: number;
}

@Component({
  selector: 'hc-operations',
  templateUrl: './operations.component.html',
  styleUrls: ['./operations.component.less'],
  imports: [TranslocoDirective, NzAffixComponent, NzPageHeaderComponent, NzPageHeaderTitleDirective, NzPageHeaderSubtitleDirective, NzCollapseComponent, NzCollapsePanelComponent, FormsModule, NzFormDirective, ReactiveFormsModule, NzRowDirective, NzColDirective, NzFormItemComponent, NzFormLabelComponent, NzFormControlComponent, NzInputNumberComponent, NzButtonComponent, NzWaveDirective, NzIconDirective, TranslocoPipe]
})
export class OperationsComponent {
  form = new FormGroup({
    orderId: new FormControl<number | null>(null, [Validators.required]),
    deliveryLat: new FormControl<number | null>(null, [Validators.required]),
    deliveryLong: new FormControl<number | null>(null, [Validators.required]),
  });
  isLoading = {
    model: false,
  };

  constructor(
    protected aRoute: ActivatedRoute,
    protected orderService: HxOrderService,
    protected router: Router,
    protected modal: NzModalService,
    protected notification: NzNotificationService,
    protected tr: TranslocoService,
  ) {
  }

  submitFormLatLong() {
    Object.values(this.form.controls).forEach(ctrl => {
      ctrl.markAsDirty();
      ctrl.updateValueAndValidity();
    });
    if (this.form.valid) {
      const formModel = this.form.getRawValue() as FormModel;

      this.isLoading.model = true;
      this.orderService.updateOrderDeliveryLatAndLong(formModel.orderId, {deliveryLat: formModel.deliveryLat, deliveryLong: formModel.deliveryLong})
        .subscribe({
          next: () => {
            this.form.markAsPristine();
            this.notification.create(
              'success',
              this.tr.translate('nav.Operations'),
              this.tr.translate('nt.dataSaved')
            );
            this.isLoading.model = false;
            this.form.reset();
          },
          error: err => {
            this.isLoading.model = false;
            this.notification.error(this.tr.translate('nav.Operations'), this.tr.translate(err.error?.message));
          }
        });
    } else {
      Object.entries(this.form.controls).forEach(([key, control]) => {
        if (control.status !== 'VALID') {
          console.log('control is not valid', key, control);
        }
      });
      console.log('not valid form', this.form);
    }
  }
}
